module.exports = "https://static.wmbcdn.com/uniweb/images/c514e90b1cfbe6684a33770351203579.svg";